window.themeJs = window.themeJs || {};


// Polyfill for IE11
if (typeof Object.assign != 'function') {
    // Must be writable: true, enumerable: false, configurable: true
    Object.defineProperty(Object, "assign", {
        value: function assign(target, varArgs) { // .length of function is 2
            'use strict';
            if (target == null) { // TypeError if undefined or null
                throw new TypeError('Cannot convert undefined or null to object');
            }

            var to = Object(target);

            for (var index = 1; index < arguments.length; index++) {
                var nextSource = arguments[index];

                if (nextSource != null) { // Skip over if undefined or null
                    for (var nextKey in nextSource) {
                        // Avoid bugs when hasOwnProperty is shadowed
                        if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                            to[nextKey] = nextSource[nextKey];
                        }
                    }
                }
            }
            return to;
        },
        writable: true,
        configurable: true
    });
}


const scrollToElements = (function($) {

    const fixedHeader = document.querySelector('.site-header');
    const offsetFromFixedHeader = 20;

    /**
     * Functions to help with smoothscrolling
     * Another library besides jQuery could be used here
     */

    const scrollToElement = function(el, offset = 0) {
        const $target = $(el);

        $('html, body').animate({
            scrollTop: $target.offset().top - (fixedHeader.offsetHeight + offsetFromFixedHeader + offset)

        }, 1000, function () {
            $target.focus();
            if ($target.is(":focus")) { // Checking if the target was focused
                return false;
            }
        });
    }
//https://stackoverflow.com/questions/17574628/scroll-to-element-in-horizontal-div
    const scrollLeftToElement = function(cont, el, offset = 0) {

        const $container = $(cont);
        const $el = $(el);
        if($el.length > 0 && $container.length > 0) {
            const left = $el.position().left;
            $container.animate({'scrollLeft': left + offset}, 250);
        }
    }

    const scrollVertInContainer = function (cont, el, offset = 0) {

        const $container = $(cont);
        const $el = $(el);

        if($el.length > 0 && $container.length > 0) {
            const elemVert = $el[0].offsetTop;
            //const contVert = $container[0].offsetTop;
          //  console.log(elemVert + ' ' + contVert);
            $container.animate({'scrollTop': elemVert + offset}, 250);
        }
    }
    return {
        scrollToElement,
        scrollLeftToElement,
        scrollVertInContainer
    };

})(jQuery);


Object.assign(themeJs, scrollToElements);
